import { Editor } from 'react-draft-wysiwyg'
import { Box } from '@mui/material'
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css'
import './Draft.scss'

const Draft = ({ value, onChange, placeholder = '' }) => {
  return (
    <Box className="draft-panel">
      <Editor
        editorState={value}
        onEditorStateChange={onChange}
        placeholder={placeholder}
        editorClassName="draft-editor"
        toolbar={{
          options: ['inline', 'blockType', 'fontSize', 'list', 'textAlign', 'link'],
          inline: {
            options: ['bold', 'italic', 'underline']
          },
          list: {
            inDropdown: true
          },
          link : {
            options: ['link']
          },
          textAlign: {
            inDropdown: true
          }
        }}
      />
    </Box>
  )
}

export default Draft;